import styled from 'styled-components/macro'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.support_error};
  color: ${({ theme }) => theme.colors.text_inverse};
  position: sticky;
  top: 0;
  z-index: 2;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.s};
  padding: 1.2rem 4.8rem 1.2rem 1.8rem;

  @media (min-width: 768px) {
    padding: 1.2rem 5.6rem 1.2rem 2.4rem;
  }
`

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.2rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 2.4rem;
  }
`

export const TextContent = styled.div`
  text-align: left;
`

export const Headline = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.s};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  line-height: ${({ theme }) => theme.lineHeights.default};
`

export const Body = styled.p`
  margin: 0.4rem 0 0 0;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: ${({ theme }) => theme.lineHeights.default};
`

export const CtaLink = styled.a`
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.text_inverse};
  color: ${({ theme }) => theme.colors.support_error};
  border-radius: 0.4rem;
  padding: 0.8rem 1.6rem;
  font-size: ${({ theme }) => theme.fontSizes.s};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 0.8rem;
  right: 1.6rem;
  display: flex;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.text_inverse};

  &:hover {
    cursor: pointer;
  }
`
